<template>
  <div>
    <el-drawer
      :modal-append-to-body="false"
      :title="title"
      :visible.sync="drawer"
      size="100%"
      :wrapperClosable="false"
      @close="closeDrawer"
    >
      <template slot="title">
        <div style="display: flex; justify-content: space-between">
          <div>{{ title }}</div>
          <el-button
            type="primary"
            @click="downloadPDF"
            style="margin-right: 50px"
            >下载PDF</el-button
          >
        </div>
      </template>
      <div class="div" v-loading="loading">
        <div class="div-content">
          <div class="w100">
            <div class="w100" style="width: 1000px; margin: 0 auto" id="aaa">
              <div class="a1 w100" ref="a1">
                <div class="title">
                  <span>{{ ProjectInfo.Name || '' }}</span
                  ><br /><br />
                  <span>{{ dataInfo.Name }}</span>
                </div>
                <div class="cover">
                  <img class="proImg" :src="ProjectInfo.ProjectImg" />
                  <div class="i-tit" style="margin-top: 100px">呈送：</div>
                  <div class="i-tit">
                    准备：{{ ProjectInfo.Property_Company }}
                  </div>
                  <div class="i-tit">
                    日期：{{ moment().format('YYYY 年 MM 月 DD 日') }}
                  </div>
                </div>
              </div>
              <div class="interpret" id="pdfContent" ref="pdfContent">
                <!-- <div class="title tac">
                  {{ dataInfo.Name }}
                </div> -->
                <div style="margin-bottom: 20px">
                  <el-descriptions class="margin-top" :column="3" border>
                    <el-descriptions-item
                      label="日期范围"
                      :labelStyle="{
                        width: '120px',
                      }"
                      :contentStyle="{
                        width: '300px',
                      }"
                    >
                      {{
                        `${moment(searchData.StartYearMonth).format(
                          'YYYY年MM月'
                        )}至${moment(searchData.EndYearMonth).format(
                          'YYYY年MM月'
                        )}`
                      }}
                    </el-descriptions-item>
                    <el-descriptions-item
                      label="位置范围"
                      :labelStyle="{
                        width: '120px',
                      }"
                      :contentStyle="{
                        width: '300px',
                      }"
                      v-if="searchData.BuildingId"
                    >
                      <el-tag
                        type=""
                        v-for="item in searchData.BuildingInfo"
                        :key="item.Id"
                        style="margin-right: 10px"
                        >{{ item.Name }}</el-tag
                      >
                    </el-descriptions-item>
                    <el-descriptions-item
                      label="类型范围"
                      :labelStyle="{
                        width: '120px',
                      }"
                      :contentStyle="{
                        width: '300px',
                      }"
                      v-if="searchData.DeviceType"
                    >
                      <el-tag
                        type=""
                        v-for="item in searchData.DeviceTypeInfo"
                        :key="item.Id"
                        style="margin-right: 10px"
                        >{{ item.DicName }}</el-tag
                      >
                    </el-descriptions-item>
                  </el-descriptions>
                </div>
                <div
                  v-for="(item, index) in InfoList"
                  :key="item.Id"
                  class="interpret-item"
                  v-loading="item.loading"
                >
                  <div class="echarts-item">
                    <div class="echarts-head">
                      <span>({{ index + 1 }}).</span> {{ item.Name }}
                    </div>
                    <div class="w100 echarts-list">
                      <div
                        v-for="(ec, ind) in item.analysisDataInterfaces"
                        :key="ec.DataInterface + ind"
                        class="echarts-info"
                        :ref="'echarts-info-' + item.Id + '-' + ind"
                        :style="`width:${
                          100 /
                          (item.DataRows ? item.DataRows : item.DataImgQuantity)
                        }%`"
                      >
                        <div v-if="ec.DataType === 4" class="type-text">
                          <div
                            v-for="(vv, ii) in ec.chartData"
                            :key="vv.name + ii"
                            class="type-text-item"
                            :style="`width: ${100 / ec.chartData.length}%;`"
                          >
                            <div>{{ vv.name }}</div>
                            <div>{{ vv.value }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="summarize" v-html="item.summary"></div>
                </div>
                <div class="sumUp" v-html="sumUp" v-if="sumUp"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import tools from '@/utils/tools'
import * as echarts from 'echarts'
import Token from '@/utils/cache/TokenCache.js'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      moment,
      drawer: false,
      loading: false,
      InfoList: [],
      isData: false,
      dataInfo: {},
      title: '',
      searchData: {},
      sumUp: '',
      uuid: '',
      autoScroll: true, // 新增
      sourceSub: null,
      ProjectInfo: {},
      isPdf: false,
    }
  },
  props: {},
  components: {},
  methods: {
    deteleData() {
      this.$http
        .post(
          `/AnalysisManage/Analysis_TemplateDetailsSource/AnalysisTemplateDetailsSourceDeleteData?UniqueId=${this.uuid}`
        )
        .then((res) => {
          if (res.Success) {
            console.log('删除生成记录成功')
          }
        })
    },
    handleScroll() {
      // 新增
      const divContent = this.$el.querySelector('.div-content')
      if (!divContent) return
      const isBottom =
        divContent.scrollHeight -
          divContent.scrollTop -
          divContent.clientHeight <
        2
      this.autoScroll = isBottom
    },
    async openInfo(title, obj, searchData) {
      this.uuid = require('node-uuid').v4()
      this.dataInfo = {}
      this.drawer = true
      this.dataInfo = obj
      this.sumUp = ''
      this.searchData = searchData
      this.title = title || '分析详情'
      this.isPdf = true
      await this.$nextTick()
      // 绑定scroll事件（只在drawer为true时绑定）
      if (this.drawer) {
        const divContent = this.$el.querySelector('.div-content')
        if (divContent) {
          divContent.addEventListener('scroll', this.handleScroll, {
            passive: true,
          })
        }
      }
      this.getDom()
    },
    closeDrawer() {
      // 新增
      this.drawer = false
      // 解绑scroll事件
      const divContent = this.$el.querySelector('.div-content')
      if (divContent) {
        divContent.removeEventListener('scroll', this.handleScroll)
      }
    },
    async getDom() {
      this.InfoList = []
      for (let item of this.dataInfo.Content || this.dataInfo.content || []) {
        if (!this.drawer) {
          break
        }
        this.$set(item, 'loading', true)
        // 初始化总结summary
        this.$set(item, 'summary', '')
        console.log('111111111111111111111')
        for (let ec of item.analysisDataInterfaces) {
          // 请求数据
          const res = await this.$http.post(ec.DataInterface, {
            ...this.searchData,
          })
          ec.chartData = res.Data?.EChartsDataList || []
          console.log('22222222222222')
        }

        let itemValue = { ...item }
        this.InfoList.push(itemValue)

        //等待渲染dom
        await this.$nextTick()
        console.log('333333333')
        this.scrollToBottom() // 新增：每次push后滚动到底部
        itemValue.analysisDataInterfaces.forEach((ec, ind) => {
          if (ec.DataType === 4) {
            return
          }
          const refName = 'echarts-info-' + itemValue.Id + '-' + ind
          const dom = this.$refs[refName]
          const chartDom = Array.isArray(dom) ? dom[0] : dom
          console.log('44444444444444')
          console.log(ec, '图标数据')
          if (chartDom) {
            const myChart = echarts.init(chartDom)
            const option = this.getEchartsOption(ec)
            this.$set(itemValue, 'loading', false)
            myChart.setOption(option)
          }
        })
        console.log('555555555555')
        this.scrollToBottom() // 新增：渲染ECharts后滚动到底部
        // 渲染完ECharts后，请求SSE接口
        await this.getSummaryBySSE(itemValue)
      }
      this.getsumUpSSE()
    },
    //总结ai
    getsumUpSSE() {
      return new Promise((resolve) => {
        if (!this.dataInfo.Aiinterface) {
          resolve()
        }
        // 获取 token 并拼接到 url 上
        const token = Token.getToken()
        // 拼接searchData参数
        let searchParams = ''
        if (this.searchData && typeof this.searchData === 'object') {
          searchParams = Object.keys(this.searchData)
            ?.map(
              (key) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(
                  this.searchData[key]
                )}`
            )
            .join('&')
        }
        const url = `${this.$rootUrl}${this.dataInfo.Aiinterface}?Id=${
          this.dataInfo.Id
        }${searchParams ? `&${searchParams}` : ''}&token=${encodeURIComponent(
          token
        )}&UserId=${this.userInfo.Id}&UniqueId=${this.uuid}`
        this.source = new EventSource(url)

        let summaryText = ''
        this.sumUp = '总结数据分析中...'

        this.source.onmessage = (event) => {
          try {
            //如果页面关闭 则断开链接
            if (!this.drawer) {
              this.source.close()
              resolve()
            }
            const data = JSON.parse(event.data)
            // 拼接内容
            const content = data.choices?.[0]?.delta?.content || ''

            summaryText += content
            this.sumUp = summaryText
            this.scrollToBottom() // 新增：AI吐字时滚动到底部
            // this.scrollToBottom();

            // 检查是否结束
            const finishReason = data.choices?.[0]?.finish_reason
            if (finishReason !== null && finishReason !== undefined) {
              console.log(1)
              this.source.close()
              this.sumUp = summaryText || '无分析结果'
              this.$notify.success('已分析完成')
              this.isPdf = false
              resolve()
            }
          } catch (e) {
            // 解析失败，忽略本条
          }
        }

        this.source.onerror = () => {
          console.log(2)
          this.source.close()
          if (!summaryText) {
            this.sumUp = '总结分析失败'
          }
          resolve()
        }

        // // 超时保护
        // const timeout = setTimeout(() => {
        //   console.log(3);
        //   source.close();
        //   if (!summaryText) {
        //     item.summary = "AI分析超时";
        //   }
        //   resolve();
        // }, 15000);

        this.source.onclose = () => {
          // clearTimeout(timeout);
        }
      })
    },
    scrollToBottom() {
      this.$nextTick(() => {
        if (!this.autoScroll) return
        const divContent = this.$el.querySelector('.div-content')
        if (divContent) {
          divContent.scrollTop = divContent.scrollHeight
        }
      })
    },
    getDataInfo() {
      this.loading = true
      this.$http
        .post(
          '/AnalysisManage/Analysis_Template/GetAnalysisTemplateData?Id=1263368318757113860',
          {}
        )
        .then((res) => {
          this.loading = false

          //   "Name" 图表标题名称
          //   "Sort": 排序

          //   "DataInterface" 图表接口,
          //   "DataImgType"  图表类型  line 折线图 bar 柱状图 pie 饼图  sunburst 旭日图,
          //   "DataType": "2"  图标数据返回的数据结构类型 1 一维数组 2 二维数组  3 二维数组 0 树结构 ,
          //   "DataImgQuantity": 图表的数量 默认1 ,
          //   "analysisDataInterfaces": [
          //     {
          //       "DataInterface": "", // 图表接口
          //       "DataImgType": "", // 图表类型 line 折线图 bar 柱状图 pie 饼图 sunburst 旭日图
          //       "DataType": "" // 图表数据返回的数据结构类型 1 一维数组 2 二维数组 3 三维数组 0 树结构
          //     }
          //   ], // 图表接口配置数组
          //   "DataImgQuantity": 图表的数量 默认1 ,
          //   "Aiinterface": AI分析接口 总结接口

          if (res.Success) {
            this.dataInfo = res.Data

            if (this.dataInfo.Content && this.dataInfo.Content.length > 0) {
              this.getDom()
            }
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    getEchartsOption(item) {
      // 字段适配
      const DataImgType = item.DataImgType
      const DataType = item.DataType || '1'
      const chartData = item.chartData || []
      const stepName = item.InterfaceName || ''
      // 饼图 一维
      if (DataImgType === 'pie' && DataType == '1') {
        return {
          title: { text: stepName, left: 'center' },
          tooltip: { trigger: 'item' },
          series: [
            {
              type: 'pie',
              radius: '60%',
              data: chartData,
              label: { formatter: '{b}: {c} ({d}%)' },
            },
          ],
        }
      }
      // 柱状图 一维
      if (DataImgType === 'bar' && DataType == '1') {
        return {
          title: { text: stepName, left: 'center' },
          grid: { left: 60, top: 90, right: 60, bottom: 30 },
          tooltip: {},
          xAxis: {
            type: 'category',
            data: chartData?.map((i) => i.name),
          },
          yAxis: { type: 'value' },
          label: {
            show: true,
            // position: "top",
            formatter: function (params) {
              return params.value === 0 ? '' : params.value
            },
          },
          series: [
            {
              type: 'bar',
              data: chartData?.map((i) => i.value),
            },
          ],
        }
      }
      // 柱状图 二维
      if (DataImgType === 'bar' && DataType == '2') {
        const xAxisData = (chartData[0]?.value || [])?.map((i) => i.name)
        return {
          title: { text: stepName, left: 'center' },
          grid: { left: 60, top: 90, right: 60, bottom: 30 },
          tooltip: {},
          legend: {
            data: chartData?.map((i) => i.name),
            type: 'scroll',
            top: 40,
          },
          xAxis: { type: 'category', data: xAxisData },
          yAxis: { type: 'value' },
          label: {
            show: true,
            // position: "top",
            formatter: function (params) {
              return params.value === 0 ? '' : params.value
            },
          },
          series: chartData?.map((i) => ({
            name: i.name,
            type: 'bar',
            stack: 'total',
            data: i.value?.map((v) => v.value),
          })),
        }
      }
      // 柱状图 三维
      if (DataImgType === 'bar' && DataType == '3') {
        // 适配你提供的数据结构
        // chartData: [{ name: "水暖专业设备", value: [{ name: "工单量", value: [{ name: "202408", value: 0 }, ...] }, { name: "完成量", value: [...] }] }, ...]
        // 1. 获取所有月份
        let xAxisData = []
        if (
          chartData.length > 0 &&
          chartData[0].value &&
          chartData[0].value.length > 0 &&
          chartData[0].value[0].value
        ) {
          xAxisData = chartData[0].value[0].value?.map((v) => v.name)
        }
        // 2. legend为 设备类型-数据类型
        let legendData = []
        chartData.forEach((dev) => {
          ;(dev.value || []).forEach((type) => {
            legendData.push(`${dev.name}-${type.name}`)
          })
        })
        // 3. series
        let series = []
        chartData.forEach((dev) => {
          ;(dev.value || []).forEach((type) => {
            series.push({
              name: `${dev.name}-${type.name}`,
              type: 'bar',
              stack: dev.name, // 按设备类型堆叠
              data: (type.value || [])?.map((v) => v.value),
            })
          })
        })

        return {
          title: { text: stepName, left: 'center' },
          grid: { left: 60, top: 90, right: 60, bottom: 30 },
          tooltip: {},
          legend: { data: legendData, type: 'scroll', top: 40 },

          xAxis: { type: 'category', data: xAxisData },
          yAxis: { type: 'value' },
          label: {
            show: true,
            formatter: function (params) {
              return params.value === 0 ? '' : params.value
            },
          },
          series,
        }
      }
      // 折线图 二维
      if (DataImgType === 'line' && DataType == '2') {
        const xAxisData = (chartData[0]?.value || [])?.map((i) => i.name)
        return {
          title: { text: stepName, left: 'center' },
          tooltip: { trigger: 'axis' },
          grid: { left: 60, top: 90, right: 60, bottom: 30 },
          legend: {
            data: chartData?.map((i) => i.name),
            type: 'scroll',
            top: 40,
          },
          xAxis: { type: 'category', data: xAxisData },
          yAxis: { type: 'value' },
          series: chartData?.map((i) => ({
            name: i.name,
            type: 'line',
            data: i.value?.map((v) => v.value),
          })),
        }
      }

      // 旭日图 树结构
      if (DataImgType === 'sunburst' && DataType == '0') {
        return {
          title: { text: stepName, left: 'center' },
          tooltip: {
            //tip提示框
            trigger: 'item',
          },
          series: [
            {
              type: 'sunburst',
              data: chartData,
              radius: ['10%', '90%'],
              clockwise: true,
              itemStyle: {
                borderWidth: 2,
              },
              label: { rotate: 'radial', align: 'center', formatter: '{b}' },
            },
          ],
        }
      }
      // 兜底
      return {
        title: { text: stepName, left: 'center' },
        series: [],
      }
    },
    async downloadPDF() {
      const pdfContent = this.$refs.pdfContent
      const a1 = this.$refs.a1
      const pdfName = (this.dataInfo.Name || '报告') + '.pdf'
      await tools.downloadPDF(a1, pdfContent, pdfName)
    },
    getSummaryBySSE(item) {
      return new Promise((resolve) => {
        if (!item.Aiinterface) {
          resolve()
        }
        // 获取 token 并拼接到 url 上
        const token = Token.getToken()
        // 拼接searchData参数
        let searchParams = ''
        if (this.searchData && typeof this.searchData === 'object') {
          searchParams = Object.keys(this.searchData)
            ?.map(
              (key) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(
                  this.searchData[key]
                )}`
            )
            .join('&')
        }
        const url = `${this.$rootUrl}${item.Aiinterface}?Id=${item.Id}${
          searchParams ? `&${searchParams}` : ''
        }&token=${encodeURIComponent(token)}&UserId=${
          this.userInfo.Id
        }&UniqueId=${this.uuid}`
        const source = new EventSource(url)
        this.$set(item, 'summary', '')
        let summaryText = ''
        item.summary = '数据分析中...'

        source.onmessage = (event) => {
          try {
            //如果页面关闭 则断开链接
            if (!this.drawer) {
              source.close()

              resolve()
            }
            const data = JSON.parse(event.data)
            // 拼接内容
            const content = data.choices?.[0]?.delta?.content || ''
            // console.log(content, "contentcontentcontentcontentcontentcontentcontent");
            summaryText += content
            item.summary = summaryText
            this.scrollToBottom() // 新增：AI吐字时滚动到底部
            // this.scrollToBottom();

            // 检查是否结束
            const finishReason = data.choices?.[0]?.finish_reason
            if (finishReason !== null && finishReason !== undefined) {
              console.log(1)
              source.close()
              item.summary = summaryText || '无AI分析结果'

              resolve()
            }
          } catch (e) {
            // 解析失败，忽略本条
          }
        }

        source.onerror = () => {
          console.log(2)
          source.close()
          if (!summaryText) {
            item.summary = 'AI分析失败'
          }
          resolve()
        }

        // // 超时保护
        // const timeout = setTimeout(() => {
        //   console.log(3);
        //   source.close();
        //   if (!summaryText) {
        //     item.summary = "AI分析超时";
        //   }
        //   resolve();
        // }, 15000);

        source.onclose = () => {
          // clearTimeout(timeout);
        }
      })
    },
    getbase64(url) {
      this.$http
        .post('/Base_Manage/Upload/ImageUrlToBase64?urls=' + url, {})
        .then((res) => {
          if (res.Success) {
            this.ProjectInfo.ProjectImg = res.Data || ''
          }
        })
    },
  },
  mounted() {
    this.$nextTick(() => {
      const divContent = this.$el.querySelector('.div-content')
      if (divContent) {
        divContent.addEventListener('scroll', this.handleScroll, {
          passive: true,
        })
      }
    })
  },
  beforeDestroy() {
    const divContent = this.$el.querySelector('.div-content')
    if (divContent) {
      divContent.removeEventListener('scroll', this.handleScroll)
    }
    this.deteleData()
  },
  created() {
    this.ProjectInfo = window.localStorage.getItem('ProjectInfo')
      ? JSON.parse(window.localStorage.getItem('ProjectInfo'))
      : {}
    this.getbase64(this.ProjectInfo.ProjectImg)
    // this.getDataInfo();
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    drawer(val) {
      if (!val) {
        // drawer关闭时解绑scroll事件
        const divContent = this.$el.querySelector('.div-content')
        if (divContent) {
          divContent.removeEventListener('scroll', this.handleScroll)
        }
        this.deteleData()
        this.source.close()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.div {
  padding: 10px 20px;
}
.div-content {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  position: relative;
}

.title {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 20px;
  // display: flex;
  // justify-content: space-between;
  // background: #fff;
  // position: sticky;
  // top: 0;
  // left: 0;
  // z-index: 9;
}

.interpret {
  color: #34495e;
  // font-size: 1.1em;
  // margin-bottom: 16px;
  // background: #f3f6fa;
  // border-left: 4px solid #3498db;
  padding: 12px;
  border-radius: 0 8px 8px 0;
  .interpret-item {
    margin-bottom: 40px;
    .echarts-item {
      .echarts-head {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .echarts-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
      .echarts-info {
        width: 100%;
        height: 400px;
        margin-bottom: 10px;
        // border: 1px solid #ccc;
        .type-text {
          width: 100%;
          height: 100%;
          display: flex;

          .type-text-item {
            height: 100%;
            // display: flex;
            // flex-direction: column;
            // justify-content: center;
            // align-items: center;
          }
        }
      }
    }
    .summarize {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}
.sumUp {
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
}
.cover {
  width: 100%;

  .proImg {
    width: 500px;
    height: 400px;

    margin-top: 100px;
    margin-bottom: 100px;
    margin-left: 400px;
  }
  .i-tit {
    width: 500px;

    font-size: 18px;
    // margin-top: 30px;
    // margin-bottom: 30px;
    margin: 30px auto;
    margin-left: 400px;
  }
}
.a1 {
  line-height: 1.5;
  page-break-after: always;
  margin-bottom: 50px;
  padding-top: 100px;
  //height: 1100px;
  .title {
    width: 500px;
    margin-left: 400px;
    font-size: 26px;

    font-weight: bold;
    text-align: right;
    color: #000000;
  }
  .center-title {
    font-size: 16px;
    color: #000000;
    line-height: 2.2;
  }
  .label {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
}
</style>
